var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUk = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5207_30129)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.55081 2.93359C0.96168 3.70009 0.517451 4.58354 0.258789 5.54327H4.16049L1.55081 2.93359Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.7425 5.54324C14.4838 4.58353 14.0395 3.70009 13.4504 2.93359L10.8408 5.54324H14.7425Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.258789 9.45508C0.51748 10.4148 0.961709 11.2982 1.55081 12.0647L4.1604 9.45508H0.258789Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0666 1.54986C11.3001 0.960732 10.4166 0.516504 9.45691 0.257812V4.15948L12.0666 1.54986Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.93457 13.4494C3.70106 14.0386 4.58451 14.4828 5.54422 14.7415V10.8398L2.93457 13.4494Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.54419 0.257812C4.58448 0.516504 3.70104 0.960732 2.93457 1.54983L5.54419 4.15945V0.257812Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.45703 14.7415C10.4167 14.4828 11.3002 14.0386 12.0667 13.4495L9.45703 10.8398V14.7415Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8408 9.45508L13.4504 12.0647C14.0395 11.2983 14.4838 10.4148 14.7425 9.45508H10.8408Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9365 6.52175H8.47831H8.47828V0.0634863C8.15804 0.0217969 7.83155 0 7.5 0C7.16839 0 6.84196 0.0217969 6.52175 0.0634863V6.52169V6.52172H0.0634863C0.0217969 6.84196 0 7.16845 0 7.5C0 7.83161 0.0217969 8.15804 0.0634863 8.47825H6.52169H6.52172V14.9365C6.84196 14.9782 7.16839 15 7.5 15C7.83155 15 8.15804 14.9782 8.47825 14.9365V8.47831V8.47828H14.9365C14.9782 8.15804 15 7.83161 15 7.5C15 7.16845 14.9782 6.84196 14.9365 6.52175Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.45605 9.45706L12.8028 12.8038C12.9567 12.65 13.1036 12.4891 13.2437 12.3223L10.3784 9.45703H9.45605V9.45706Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.54308 9.45703H5.54302L2.19629 12.8038C2.35016 12.9577 2.51103 13.1045 2.67778 13.2446L5.54308 10.3793V9.45703Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.54348 5.54411V5.54405L2.19672 2.19727C2.04279 2.35113 1.89596 2.512 1.75586 2.67876L4.62118 5.54408H5.54348V5.54411Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.45605 5.54351L12.8028 2.19669C12.649 2.04276 12.4881 1.89593 12.3213 1.75586L9.45605 4.62118V5.54351Z",
  fill: "#D80027"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5207_30129"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUk);
export { ForwardRef as ReactComponent };